<template>
  <div class="page-content">
    <page-template
      ref="batchTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  components: {
    pageTemplate,
  },
  data() {
    return {
      listShow: false,
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "",
            prop: "name",
            type: "input",
            ifFuzzy: true,
            placeholder: "名称",
          },
        ],
        complex: [
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 12,
            data: [],
            url: api.store.store,
          },
          {
            label: "类型",
            prop: "status",
            type: "radio",
            data: this.$utils.getCacheStatus("wgTaste.type"),
            span: 24,
          },
        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: "新增",
          code: "insert",
        },
        {
          label: "删除",
          type: this.$utils.buttonType.tableOperate,
          code: "delete",
        },
        {
          label: "刷新",
          callback: this.refresh,
          code: "refresh",
        },
        {
          label: "编辑",
          code: "update",
          type: this.$utils.buttonType.tableOperate,
        },
      ],
      // 表格信息配置
      tableOptions: {
        showSelect: true,
        // indexShow: true,//是否显示索引
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "120",
            align: "center",
          },
          {
            label: "类型",
            prop: "type",
            width: "100",
            enumData: this.$utils.getCacheStatus("wgTaste.type"),
            align: "center",
          },
          {
            label: "名称",
            prop: "name",
            width: "100",
            align: "center",
          },
          {
            label: "金额/折扣比率",
            prop: "amount",
            width: "100",
            align: "center",
          },
          {
            label: "状态",
            prop: "status",
            width: "90",
            enumData: this.$utils.getCacheStatus("wgTaste.status"),
            align: "center",
          },
          {
            label: "备注",
            prop: "remarks",
            width: "100",
            align: "center",
          },
        ],
        url: api.weigh.taste,
      },
      // 添加字段
      addColumns: {
        labelWidth: "120px",
        span: 12,
        columns: [
          {
            label: "门店",
            type: "select",
            prop: "storeId",
            data: [],
            url: api.system.seStore,
            rule: [{ required: true, message: "请选择门店", trigger: "blur" }],
          },
          {
            label: "名称",
            type: "input",
            prop: "name",
            placeholder: "请输入名称",
            rule: [{ required: true, message: "请输入名称", trigger: "blur" }],
          },
          {
            label: "类型",
            type: "select",
            prop: "type",
            data: this.$utils.getCacheStatus("wgTaste.type"),
            rule: [
              {
                required: true,
                message: "请输入采购员手机号",
                trigger: "blur",
              },
            ],
            change: this.typeChange,
          },
          {
            label: "金额/折扣比率",
            type: "input",
            prop: "amount",
          },
          {
            label: "状态",
            type: "select",
            prop: "status",
            data: this.$utils.getCacheStatus("wgTaste.status"),
            defaultValue: 10,
          },
          {
            label: "备注",
            type: "textarea",
            span: 22,
            prop: "remarks",
          },
        ], // 表单label
        url: api.weigh.taste,
      },
      checkIndex: "",
    };
  },
  created() {
    this.setStore(this.searchOptions.complex);
  },
  methods: {
    typeChange(data) {
      let type = data["type"];
      let amount = this.addColumns.columns.filter(
        (item) => item.prop === "amount"
      )[0];
      if (20 === type) {
        amount.label = "金额";
      } else if (30 === type) {
        amount.label = "折扣比率";
      } else {
        amount.label = "金额/折扣比率";
      }
    },
    refresh() {
      this.$router.go(0);
    },
    delete() {
      let tableRows = this.$refs.batchTemplate.getTableSelectRow();
      this.updateAsGoods(this.getSearchParam(tableRows, 99));
    },
    getSearchParam(row, params) {
      let ids = row.map((item) => {
        return item.id;
      });
      return {
        ...{ ids: ids },
        status: params,
      };
    },
    updateAsGoods(searchParam) {
      this.$axios
        .fetchPut(api.weigh.taste, searchParam)
        .then((data) => {
          this.loading = false;
          if (data.code == 200) {
            this.$router.go(0);
          } else {
            this.$message({ message: data.msg, type: "error" });
          }
        })
        .catch((err) => {
          this.$message({ message: "请求失败！", type: "error" });
          this.loading = false;
        });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/page/weigh/speciality/Taste.vue